// Main navigation, grouped into sections.
// - `access` hides a section/item unless the user has that permission.
// - `railGroup` sections collapse into one fly-out icon on the narrow rail;
//   other sections show each item as its own rail icon.
// - `badge` names a live indicator computed in SideNav (e.g. 'paymentDue').
const sections = [
  {
    id: 'society',
    title: 'Society',
    items: [
      { to: '/updates', icon: 'albums-outline', label: 'Circular/Notices/Minutes', short: 'Notices' },
      { to: '/timeline', icon: 'hourglass-outline', label: 'Project Layout and designs', short: 'Designs' },
      { to: '/documents', icon: 'document-attach-outline', label: 'Project management details', short: 'Docs' },
      { to: '/', icon: 'business-outline', label: 'Construction', short: 'Build', end: true },
      { to: '/poll', icon: 'analytics-outline', label: 'Polls', short: 'Polls' },
      { to: '/forms', icon: 'document-outline', label: 'Forms', short: 'Forms' },
    ]
  },
  {
    id: 'my-flat',
    title: 'My Flat',
    icon: 'home-outline',
    short: 'My Flat',
    railGroup: true,
    items: [
      { to: '/singleuserunitplan', icon: 'grid-outline', label: 'My unit plan' },
      { to: '/payment-details', icon: 'wallet-outline', label: 'Details of payment', badge: 'paymentDue' },
      { to: '/msg', icon: 'chatbubbles-outline', label: 'Communication' },
    ]
  },
  {
    id: 'admin',
    title: 'Administration',
    icon: 'shield-checkmark-outline',
    short: 'Admin',
    railGroup: true,
    // admins only — members see just their own unit plan under "My Flat"
    access: 'ListUser',
    items: [
      { to: '/alluserunitplan', icon: 'people-outline', label: 'All Users unit plan' },
      { to: '/payment-details', icon: 'cash-outline', label: 'Users Details of payment' },
      { to: '/allusers', icon: 'person-add-outline', label: 'Manage users' },
    ]
  },
]

export const canSee = (entry, userAccess) =>
  !entry.access || (Array.isArray(userAccess) && userAccess.includes(entry.access))

export default sections
